<template>
  <div class="retail-search">
    <mu-appbar class="XR-search-head">
      <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>        
      <div slot="default" class="search-ctrl">
        <input class="input-ctrl" placeholder="请输入订单号" type='number' v-model="searchkey" />          
      </div>
      <mu-flat-button v-on:click="goSearch" slot="right">搜索</mu-flat-button>    
    </mu-appbar>

    <div class="hotSearch">
      <mu-sub-header>搜索历史</mu-sub-header>
      <div class="hot-list">
        <div v-for="hItem in historyOrderSearch" :key="hItem">
          {{hItem}}
        </div>
      </div>
    </div>
    
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchkey : '',
      historyOrderSearch:[]
    }
  },
  mounted: function() {
    
  },
  methods: {
    // getHistorySearch(){
    //   var listJson = this.getSearchCache();
    //   if(listJson){
    //     this.historyOrderSearch = listJson;
    //   }
    // },
    GoHistory(){      
      this.$router.goBack()
    },
    hotSearch: function(key){
      var param ='?logNo='+ key
      this.$router.push('/shangquan/offlinePayList'+param)
    },
    goSearch: function(){
      var param =''
      if(this.searchkey){
        param ='?logNo='+this.searchkey
      }
      this.$router.push('/shangquan/offlinePayList'+param)
    },
    // AddSearchCache(searchKey){
    //   var list = this.getSearchCache()
    //   if(!list){
    //     list = []
    //   }
    //   list.push(searchKey)
    // },
    // getSearchCache(){
    //   return window.localStorage.RetailOrderListSearch
    // }
  }
};
</script>

<style>
.retail-search .hotSearch{
  overflow: hidden;
  background: white;
}
.retail-search .hotSearch .hot-list{
  overflow: hidden;
  padding: 0 16px 16px;
}
.retail-search .hotSearch .hot-list .hot-item{
  float: left;
  padding: 0 10px;
  background: #F0F2F5;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.retail-search .hotSearch .hot-list .hot-item ~ .hot-item{
}


.retail-search .XR-search-head{
  height: 48px;
  text-align: center;
}
.retail-search .XR-search-head.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.retail-search .XR-search-head .mu-appbar-title {
  font-size: 16px;
}
.retail-search .XR-search-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.retail-search .XR-search-head .title .title-text {
  margin: 0;
  line-height: 48px;
}


.retail-search .XR-search-head .search-ctrl{
  height: 32px;
  line-height: 32px;
  border-radius: 25px;
  padding-right: 10px;
  color:#ccc;
  background: #999;
  overflow: hidden;
}
.retail-search .XR-search-head .search-ctrl .input-ctrl{
  float: left;
  line-height: 32px;
  font-size: 12px;
  width: 90%;
  padding-left: 12px;
  background: inherit;
  border: none;
  outline :none;
  text-align: left;
  color:white;
}
.retail-search .XR-search-head .search-ctrl .icon-ctrl{
  width: 10%;
  float: right;
  line-height: 28px;
  text-align: right;
  color:#ccc;
}

.retail-search .XR-search-head-chip{
  height: 26px;
  margin-top: 3px;
  padding:0 12px 0 4px;
  border-radius: 0;
}
.retail-search .XR-search-head-chip .mu-chip-delete-icon{
  width: 16px;
  height: 16px;
}
</style>


// WEBPACK FOOTER //
// src/pages/shangquan/offlinePaySearch.vue